import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/common/BreadCrumb";
import GeneralSetting from "./GeneralSetting";
import BillingSetting from "./BillingSetting";
import BannerSetting from "./BannerSetting";
import FaqSetting from "./FaqSetting";

const MasterSetting = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("General Setting");

  const tabs = [
    {
      label: "General Setting",
      route: "general-settings",
      content: <GeneralSetting />,
    },
    {
      label: "Billing Setting",
      route: "billing-settings",
      content: <BillingSetting />,
    },
    {
      label: "FAQ Setting",
      route: "faq-settings",
      content: <FaqSetting />,
    },
    {
      label: "Banner Setting",
      route: "banner-settings",
      content: <BannerSetting />,
    },
  ];

  useEffect(() => {
    const currentTab = tabs.find((tab) =>
      location.pathname.includes(tab.route)
    );
    if (currentTab) {
      setActiveTab(currentTab.label);
    }
  }, [location.pathname]);

  const handleTabClick = (tab) => {
    setActiveTab(tab.label);
    navigate(`/${tab.route}`);
  };

  return (
    <>
      <div>
        <h6 className="font-Montserrat font-medium text-xl mb-3">
          Master Setting
        </h6>
        <Breadcrumb
          breadCrumbParent={"Home"}
          breadCrumbActive={activeTab}
          breadCrumbTitleKey={"/"}
          classes=""
        />
      </div>
      <div className="flex justify-end mb-5 mt-10 px-2 border border-borderLine rounded-2xl bg-bgWhite shadow-sm ">
        {tabs.map((tab) => (
          <button
            key={tab.label}
            className={`py-2 px-4 uppercase text-[14px] border-b-2 transition duration-300 font-Proxima ${
              activeTab === tab.label
                ? "border-themeBtn text-themeBtn"
                : "border-transparent text-textSecondary hover:text-themeBtn hover:border-themetext-themeBtn"
            } w-full font-normal my-2 h-full`}
            onClick={() => handleTabClick(tab)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>
        {tabs.map(
          (tab) =>
            activeTab === tab.label && <div key={tab.label}>{tab.content}</div>
        )}
      </div>
    </>
  );
};

export default MasterSetting;
